var React = require('react');

function PasswordLockLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.5 17.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-9.5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM47 42H29a1 1 0 01-1-1V25a1 1 0 011-1h18a1 1 0 011 1v16a1 1 0 01-1 1zm-17-2h16V26H30v14z","key":0}),React.createElement("path",{"d":"M38 36.63a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm0-5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM43 26H33a1 1 0 01-1-1v-3a6 6 0 1112 0v3a1 1 0 01-1 1zm-9-2h8v-2a4 4 0 10-8 0v2z","key":1}),React.createElement("path",{"d":"M25 26H5a5 5 0 01-5-5V11a5 5 0 015-5h38a5 5 0 015 5v10a1 1 0 01-2 0V11a3 3 0 00-3-3H5a3 3 0 00-3 3v10a3 3 0 003 3h20a1 1 0 010 2z","key":2})]);
}

PasswordLockLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PasswordLockLight;

PasswordLockLight.default = PasswordLockLight;
